module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedLight.3fcb2ae.woff2";